"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const CalendarCard_1 = require("./CalendarCard");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            previous: null,
            direction: null,
        };
        this.cardCount = 5;
        this.previous = () => {
            if (this.state.direction) {
                return;
            }
            if (this.state.current === 0) {
                return;
            }
            this.setState({
                current: this.state.current - 1,
                previous: this.state.current - 1,
                direction: 'previous'
            });
        };
        this.next = () => {
            if (this.state.direction) {
                return;
            }
            if (this.state.current >= this.props.days.length - this.cardCount) {
                return;
            }
            this.setState({
                current: this.state.current + 1,
                previous: this.state.current,
                direction: 'next'
            });
        };
        this.onTransitionEnd = () => {
            this.setState({
                previous: null,
                direction: null
            });
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { days, active } = this.props;
        return (React.createElement("div", { className: "DatePicker" }, days.length > 0 && (React.createElement("nav", { className: "calendar" },
            React.createElement("div", { className: "card-container" },
                React.createElement("div", { className: "cards" }, days.map((day, index) => (React.createElement("div", { key: index, className: `card-item ${this.getClass(index)}`, onTransitionEnd: this.onTransitionEnd },
                    React.createElement(CalendarCard_1.CalendarCard, { active: moment(active.date).isSame(day.date, 'day'), date: day.date, onClick: () => this.props.setActiveDay(day) }))))),
                React.createElement("div", { className: "navigation" },
                    React.createElement("button", { className: "icon-button is-large", onClick: this.previous }, this.hasPrevious() ? (React.createElement("img", { src: icons_1.arrowLeftIcon, alt: "" })) : (React.createElement("img", { src: icons_1.arrowLeftInactiveIcon, alt: "" }))),
                    React.createElement("button", { className: "icon-button is-large", onClick: this.next }, this.hasNext() ? (React.createElement("img", { src: icons_1.arrowRightIcon, alt: "" })) : (React.createElement("img", { src: icons_1.arrowRightInactiveIcon, alt: "" })))))))));
    }
    hasNext() {
        return this.state.current < this.props.days.length - this.cardCount;
    }
    hasPrevious() {
        return this.state.current > 0;
    }
    getClass(index) {
        const direction = this.state.direction;
        const current = this.state.current;
        if (direction === null) {
            if (index >= current && index < current + this.cardCount) {
                return '';
            }
            return 'is-inactive';
        }
        const previous = this.state.previous;
        if (index === previous) {
            return direction === 'next' ? 'leaving-left five' : 'entering-left five';
        }
        if (index === previous + this.cardCount) {
            return direction === 'next' ? 'entering-right five' : 'leaving-right five';
        }
        if (index > previous && index < previous + this.cardCount) {
            return direction === 'next' ? 'moving-left five' : 'moving-right five';
        }
        return 'is-inactive';
    }
}
exports.DatePicker = DatePicker;
exports.default = DatePicker;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-date-picker/DatePicker.tsx